// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceResult_container__3unID","chart":"PriceResult_chart__347Qp","faqBorder":"PriceResult_faqBorder__2mtsU","bannerWrapper":"PriceResult_bannerWrapper__2FFF3"};